import '../plugins/StickySidebarPlugin.js';
import '../plugins/ResponsiveHelper.js';

export default function StickySidebar() {
	const $header = jQuery('#header');

    ResponsiveHelper.addRange({
        '1024..': {
            on: function() {
                jQuery('.js-sidebar_sticky').each(function() {
                    if (this.dataset.destroyTimer) {
                        clearTimeout(this.dataset.destroyTimer);
                    }

                    const $stickySidebar = jQuery(this);
                    const innerBlock = this.querySelector('.js-sidebar_inner');

                    const stickySidebar = $stickySidebar.stickySidebar({
                        containerSelector: '.js-sidebar_holder',
                        innerWrapperSelector: '.js-sidebar_inner',
                        topSpacing: 100,
                        bottomSpacing: 0,
                        resizeSensor: false
                    }).data('stickySidebar');

                    const resizeObserver = new ResizeObserver((entries) => {
                        stickySidebar.updateSticky();
                    });

                    resizeObserver.observe(document.body);

                    if (innerBlock) {
                        resizeObserver.observe(innerBlock);
                    }

                    $stickySidebar.data('resizeObserver', resizeObserver);

                    stickySidebar.updateSticky();
                });
            },
            off: function() {
                jQuery('.js-sidebar_sticky').each(function() {
                    const $stickySidebar = jQuery(this);
                    const $innerBlock = $stickySidebar.find('.js-sidebar_inner');
                    const inst = $stickySidebar.data('stickySidebar');
                    const resizeObserver = $stickySidebar.data('resizeObserver');

                    if (resizeObserver) {
                        resizeObserver.unobserve(document.body);

                        $innerBlock.each(function() {
                            resizeObserver.unobserve(this);
                        });
                    }

                    this.dataset.destroyTimer = setTimeout(function() {
                        if (inst) {
                            inst.destroy();
                            $stickySidebar.removeData('stickySidebar');
                        }
                    }, 50);
                });
            }
        }
    });

  jQuery('.js-sidebar_sticky_exhibitor').each(function() {
    const $stickySidebar = jQuery(this);
    const innerBlock = this.querySelector('.js-sidebar_inner');
    const stickySidebar = $stickySidebar.stickySidebar({
      containerSelector: '.js-sidebar_holder',
      innerWrapperSelector: '.js-sidebar_inner',
      topSpacing: 0,
      bottomSpacing: 0,
      resizeSensor: false,
    }).data('stickySidebar');
    const resizeObserver = new ResizeObserver(() => {
      stickySidebar.updateSticky();
    });
    resizeObserver.observe(document.body);
    if (innerBlock) {
      resizeObserver.observe(innerBlock);
    }
    stickySidebar.updateSticky();
  });
}
